import {
  Alert,
  AppBar,
  Box,
  LinearProgress,
  List,
  Paper,
  Tab,
  Tabs,
} from "@mui/material";
import React, { FC } from "react";
import { ListItem } from "./ListItem";
import { IChamada } from "../GerenciarAula";
import { IDiaAula, IHorarioAulaDiaAula } from "@deltasge/marauders-map";
import { useAppSelector } from "store";
import { Float } from "components/Buttons/Float";
import { ProviderScroll } from "context/ScrollContext";
import { AccountConvert as AlunoIcon } from "mdi-material-ui";

export const Alunos: FC<{
  alunos: IChamada[];
  aula: IDiaAula;
  horarios?: IHorarioAulaDiaAula[];
  apagarFalta: (aluno: IChamada) => Promise<void>;
  gerarFalta: (aluno: IChamada) => Promise<void>;
  handleChangeAula: (horario: IHorarioAulaDiaAula) => Promise<void>;
  handleAlunosRecuperacao: () => void;
  loading: boolean;
}> = ({
  alunos,
  aula,
  apagarFalta,
  gerarFalta,
  horarios,
  handleChangeAula,
  handleAlunosRecuperacao,
  loading,
}) => {
  const {
    layout: { option },
  } = useAppSelector((state) => state);

  const position = option?.aulaGeminadaPosition || "top";
  const hasHorario = !!horarios && horarios.length > 1;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {hasHorario && position == "top" && (
        <AppBar
          position="relative"
          sx={{
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            pt: 0.5,
          }}
          variant="outlined"
          elevation={0}
          color="inherit"
        >
          <Tabs
            centered
            value={aula.aula}
            scrollButtons
            allowScrollButtonsMobile
            onChange={(e, aula) => {
              const horario = horarios.find((h) => h.aula == aula);
              if (horario) handleChangeAula(horario);
            }}
          >
            {horarios.map((horario, index) => (
              <Tab
                key={`aula-geminada-${index}`}
                value={horario.aula}
                label={horario.descricao}
              />
            ))}
          </Tabs>
        </AppBar>
      )}
      <ProviderScroll
        sx={(theme) => ({
          overflowY: "auto",
          height: `calc(100% - ${theme.spacing(hasHorario ? 6.25 : 0.5)})`,
        })}
      >
        {loading && <LinearProgress sx={{ mt: 4 }} />}
        {!loading && alunos.length > 0 && (
          <List component={Paper} variant="outlined" sx={{ m: 1, p: 0 }}>
            {alunos.map((aluno, i, a) => (
              <ListItem
                key={"iAluno" + i}
                divider={i + 1 < a.length}
                aluno={aluno}
                diaAula={aula}
                apagarFalta={apagarFalta}
                gerarFalta={gerarFalta}
              />
            ))}
          </List>
        )}
        {!loading && alunos.length == 0 && aula.isRecuperacao && (
          <Alert severity="info" sx={{ m: 2 }}>
            Nenhum aluno encontrado. Use o botão abaixo para gerenciar os alunos
          </Alert>
        )}
        {aula.isRecuperacao && (
          <Float
            icon={<AlunoIcon />}
            onClick={handleAlunosRecuperacao}
            title="Gerenciar alunos"
          />
        )}
      </ProviderScroll>
      {hasHorario && position == "bottom" && (
        <AppBar
          position="absolute"
          sx={{
            top: "auto",
            bottom: 0,
            borderLeft: "none",
            borderRight: "none",
          }}
          variant="outlined"
          elevation={0}
          color="inherit"
        >
          <Tabs
            centered
            value={aula.aula}
            scrollButtons
            allowScrollButtonsMobile
            onChange={(e, aula) => {
              const horario = horarios.find((h) => h.aula == aula);
              if (horario) handleChangeAula(horario);
            }}
          >
            {horarios.map((horario) => (
              <Tab
                key={`aula-${horario.aula}`}
                value={horario.aula}
                label={horario.descricao}
              />
            ))}
          </Tabs>
        </AppBar>
      )}
    </Box>
  );
};
